import styles from "./AtualizarUsuario.module.css";
import Container from "../../components/components-ui/Container/Container";
import Button from "../../components/components-ui/Button/Button";
import api from "../../services/Api";
import { AuthContext } from "../../Provider/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Col, Grid } from "../../components/Grid";
import { SelectSearch } from "../../components/components-ui/SelectSearch/SelectSearch";
import { Table } from "../../components/Table";
import Api from "../../services/Api";
import Loading from "../../components/components-ui/Loading/Loading";
import Modal from "@mui/material/Modal";
import ModalAtualizarSenha from "./ModalAtualizarSenha/ModalAtualizarSenha";

const API_SHOW_USER = "/usuario/show";
const API_PASSWORD = "/usuario/updatepassword";
const API_UPDATE_USER = "/usuario/update";
const API_PERFIS = "/perfil/index";
const API_SHOW_ACAO_DO_PERFIL = "/usuarioacao/show/";

export default function AtualizarDados() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [perfil, setPerfil] = useState([]);
  const [permissoes, setPermissoes] = useState([]);
  const { logout, nomeUsuario, idTipoUsuario } = useContext(AuthContext);

  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg);
    } else {
      toast.error(msg);
    }
  }

  async function getPerfil() {
    await Api.get(API_PERFIS)
      .then((res) => {
        if (res.data.error === 0) {
          setPerfil(res.data.data);
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => console.log(error));
  }

  async function getAcaoDoPerfil() {
    const response = await api.get(API_SHOW_ACAO_DO_PERFIL + idTipoUsuario);
    setPermissoes(response.data.data);
  }

  useEffect(() => {
    async function getData() {
      setIsLoading(true);
      await Api.get(API_SHOW_USER)
        .then((res) => {
          console.log(res);
          if (res.data.error === 0) {
            setUserData(res.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
          showAlert(1, error.message);
        })
        .finally(() => setIsLoading(false));
    }
    getData();
    getPerfil();
    getAcaoDoPerfil();
  }, []);

  const updateUser = async (values) => {
    await api
      .post(API_UPDATE_USER, { option: values.fullscreen })
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          localStorage.setItem(
            "fullscreen",
            JSON.stringify(res.data.data.Option_MaxScreen)
          );
          window.history.back();
          return;
        }
        toast.error(res.data.error);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const validationSchema = Yup.object().shape({
    codigo: Yup.number().nullable(),
    login: Yup.string().nullable(),
    senha: Yup.string().nullable(),
    nome: Yup.string().nullable(),
    email: Yup.string().nullable(),
    status: Yup.number().nullable(),
  });
  return (
    <Container>
      <div className={styles.container}>
        <h3>Atualizar Dados Do Usuario</h3>
        <section className={styles.content}>
          <div className={styles.formUpdateUser}>
            <Formik
              initialValues={{
                codigo: userData?.IDUsuario || "",
                login: userData?.Usuario || "",
                senha: "",
                nome: userData?.NomeUsuario || "",
                perfil: userData?.IdPerfil || "",
                email: userData?.Email || "",
                status: userData?.IDStatus || "",
                fullscreen: userData?.Option_MaxScreen || 0,
              }}
              validationSchema={validationSchema}
              enableReinitialize={true}
              onSubmit={(values) => updateUser(values)}
            >
              {({ errors, touched }) => (
                <Form>
                  {isLoading ? (
                    <div className={styles.loading}>
                      <Loading />
                    </div>
                  ) : (
                    <Box border={1} padding={1}>
                      <Grid>
                        <Col size={1}>
                          <label>Código</label>
                          <Field type="number" name="codigo" disabled />
                          {errors.codigo && touched.codigo ? (
                            <span className={styles.alertError}>
                              {errors.codigo}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={4}>
                          <label>Login</label>
                          <Field type="text" name="login" disabled />
                          {errors.login && touched.login ? (
                            <span className={styles.alertError}>
                              {errors.login}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={3}>
                          <label>Senha</label>
                          <Field type="password" name="senha" disabled />
                          {errors.senha && touched.senha ? (
                            <span className={styles.alertError}>
                              {errors.senha}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={4}>
                          <label>Nome</label>
                          <Field type="text" name="nome" disabled />
                          {errors.nome && touched.nome ? (
                            <span className={styles.alertError}>
                              {errors.nome}
                            </span>
                          ) : null}
                        </Col>
                      </Grid>
                      <Grid>
                        <Col size={3}>
                          <label>Perfil</label>
                          <Field
                            type="number"
                            name="perfil"
                            component={SelectSearch}
                            disabled
                            options={perfil.map((item) => ({
                              value: item.IdPerfil,
                              label: item.Perfil,
                            }))}
                          />
                          {errors.perfil && touched.perfil ? (
                            <span className={styles.alertError}>
                              {errors.perfil}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={3}>
                          <label>Email</label>
                          <Field type="email" name="email" disabled />
                          {errors.email && touched.email ? (
                            <span className={styles.alertError}>
                              {errors.email}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={3}>
                          <label>Tipo de Tela</label>
                          <Field
                            type="number"
                            name="fullscreen"
                            component={SelectSearch}
                            options={[
                              {
                                value: 1,
                                label: "Tela Cheia",
                              },
                              {
                                value: 0,
                                label: "Modo Janela",
                              },
                            ]}
                          />
                          {errors.fullscreen && touched.fullscreen ? (
                            <span className={styles.alertError}>
                              {errors.fullscreen}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={3}>
                          <label>Status</label>
                          <Field
                            type="number"
                            name="status"
                            component={SelectSearch}
                            disabled
                            options={[
                              {
                                value: 1,
                                label: "Ativo",
                              },
                              {
                                value: 2,
                                label: "Inativo",
                              },
                            ]}
                          />
                          {errors.status && touched.status ? (
                            <span className={styles.alertError}>
                              {errors.status}
                            </span>
                          ) : null}
                        </Col>
                      </Grid>
                      <Grid>
                        <Col>
                          <Table
                            columns={[
                              {
                                column: "Permisões do usuário",
                              },
                            ]}
                          >
                            {permissoes.map(({ Acao, IdAcao }) => (
                              <tr key={IdAcao}>
                                <td>{Acao}</td>
                              </tr>
                            ))}
                          </Table>
                        </Col>
                      </Grid>
                      <section className={styles.sectionInput}>
                        <Button title="Salvar" type="submit" />
                        <Button
                          title="Atualizar Senha"
                          // type="submit"
                          type="button"
                          color={"tertiary"}
                          onClick={() => setOpenModal(true)}
                        />
                        <Button
                          color="secondary"
                          title="Voltar"
                          type="button"
                          onClick={() => window.history.back()}
                        />
                      </section>
                    </Box>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </section>
      </div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalAtualizarSenha
          setOpenModal={setOpenModal}
          closeModal={() => setOpenModal(false)}
        />
      </Modal>
    </Container>
  );
}
